<template>
  <v-dialog v-model="show" width="500">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0"
          >送信宛先の{{ type === "EDIT" ? "編集" : "追加" }}</span
        >
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="
            !receiver.buyerCode ||
            !receiver.receiverCode ||
            (!sea && !air && !truck && !rail && !mul)
          "
          @click="save()"
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="back()">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <remote-autocomplete
                  label="バイヤーコード"
                  :url="`buyers/code/kv?companyId=${company.companyId}`"
                  required
                  v-model="receiver.buyerCode"
                ></remote-autocomplete>
              </v-flex>
              <v-flex xs12>
                <remote-autocomplete
                  label="宛先名"
                  url="employees/tdoc-kv"
                  required
                  v-model="receiver.receiverCode"
                ></remote-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  disabled
                  clearable
                  label="メールアドレス"
                  required
                  v-model="receiver.receiverMail"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  disabled
                  clearable
                  label="会社名"
                  required
                  v-model="receiver.receiverCompanyName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div style="display: flex">
                  <v-checkbox
                    v-model="sea"
                    label="SEA"
                    value="TPM_SEA"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="air"
                    label="AIR"
                    value="TPM_AIR"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="truck"
                    label="Truck"
                    value="TPM_ROAD"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="rail"
                    label="RAIL"
                    value="TPM_RAIL"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="mul"
                    label="SEA&AIR"
                    value="TPM_MUL"
                  ></v-checkbox>
                </div>
              </v-flex>
              <v-flex xs12>
                <div style="display: flex">
                  <v-textarea
                    :rules="[
                      (v) =>
                        !v ||
                        (!!v && v.length <= 200) ||
                        '備考を200文字以下にしてください',
                    ]"
                    label="備考"
                    v-model="receiver.remark"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["company"],
  data() {
    return {
      show: false,
      receiver: {},
      sea: null,
      air: null,
      truck: null,
      rail: null,
      mul: null,
      currentUser: {},
      type: null,
      errors: {
        CODE_EXISTS: "buyerCode + メールアドレスが既存しています。",
      },
    };
  },
  methods: {
    popup(type, receiver) {
      this.show = true;
      this.type = type;
      this.receiver = receiver;
      if (receiver.transportModes) {
        if (receiver.transportModes.indexOf("TPM_SEA") > -1) {
          this.sea = "TPM_SEA";
        }
        if (receiver.transportModes.indexOf("TPM_AIR") > -1) {
          this.air = "TPM_AIR";
        }
        if (receiver.transportModes.indexOf("TPM_ROAD") > -1) {
          this.truck = "TPM_ROAD";
        }
        if (receiver.transportModes.indexOf("TPM_RAIL") > -1) {
          this.rail = "TPM_RAIL";
        }
        if (receiver.transportModes.indexOf("TPM_MUL") > -1) {
          this.mul = "TPM_MUL";
        }
      }
    },
    back() {
      this.show = false;
      this.receiver = {};
      this.sea = null;
      this.air = null;
      this.truck = null;
      this.rail = null;
      this.mul = null;
      this.$emit("refresh");
    },
    loadUser() {
      if (this.receiver.receiverCode) {
        this.$http
          .get(`/employees/username/${this.receiver.receiverCode}`)
          .then((res) => {
            this.currentUser = res.data;
            this.receiver.receiverMail = res.data.email;
            this.receiver.receiverCompanyName = res.data.companyName;
            this.$forceUpdate();
          });
      }
    },
    save() {
      var transportModes = [];
      transportModes.push(this.sea);
      transportModes.push(this.air);
      transportModes.push(this.truck);
      transportModes.push(this.rail);
      transportModes.push(this.mul);
      transportModes = transportModes.filter((t) => !!t);
      if (this.type !== "EDIT") {
        this.$http
          .post(`/buyers/receiver`, {
            ...this.receiver,
            parentCompanyId: this.company.companyId,
            transportModes: transportModes.join(","),
          })
          .then(() => {
            this.$message("", "送信宛先追加しました。");
            this.back();
          })
          .catch((err) => {
            this.$showError(err);
          });
      } else {
        this.$http
          .put(`/buyers/receiver`, {
            ...this.receiver,
            parentCompanyId: this.company.companyId,
            transportModes: transportModes.join(","),
          })
          .then(() => {
            this.$message("", "送信宛先更新しました。");
            this.back();
          })
          .catch((err) => {
            this.$showError(err);
          });
      }
    },
  },
  watch: {
    "receiver.receiverCode"() {
      this.loadUser();
    },
  },
};
</script>
